import React, { useContext, useEffect, useState } from "react";
import { Form, Container, Modal,  Button, Table} from "react-bootstrap";
// import { PaystackButton } from "react-paystack";
import { Store } from "../../Store";
import ToastIt from "../../components/Toast";
import axios from "axios";

function UserFinance() {
  const { state } = useContext(Store);
  const { myRecharges, userInfo, baseUrl, noticeContent, CurrUser} = state;

  const [amount, setAmount] = useState("");
  const [MyRequests, setMyRequests] = useState([]);
  const [rechargeID, setRechargeID] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [variance, setVariance] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const handleClose = () => setShowAlert(false);

  // fetch update from state
  useEffect(() => {
    if (myRecharges && myRecharges.length > 0) {
      setMyRequests(myRecharges);
    } else {
      setMyRequests([]);
    }
  }, [myRecharges]);

  // console.log('rR',rechargeRequests);

  // const handlePaystackSuccessAction = (reference) => {
  //       // Dispatch the USER_RECHARGE action to update the user's balance
  //       ctxDispatch({
  //         type: 'USER_RECHARGE',
  //         payload: parseFloat(amount),
  //       });
  //   setShowToast(true)
  //   setVariance("success");
  //   setToastMessage(`Payment made successfully with reference ${reference}`);
  // };

  // const handlePaystackCloseAction = () => {
  //   console.log("closed");
  // };

  // const paystackConfig = {
  //   reference: new Date().getTime().toString(),
  //   email: userInfo.email,
  //   currency: "GHS",
  //   amount: parseFloat(amount),
  //   publicKey: "pk_test_9844fdf4ef0a684443d7a651a6136272e4503af9",
  //   onSuccess: (reference) => handlePaystackSuccessAction(reference),
  //   onClose: handlePaystackCloseAction,
  // };

  const processRequest = async (e) => {
    e.preventDefault();
    //get next recharge ID
    setShowAlert(true);
    try {
      const { data } = await axios.get(`${baseUrl}/recharge//next-recharge-id`)
      setRechargeID(data.nextRechargeId);
      // console.log('rID',rechargeID)
    } catch (error) {
      setVariance("danger");
      setToastMessage(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
      );
      setShowToast(true);
    }
  }

  // FOR WALLET FEATURE
  const handleRequest = async (e) => {
    e.preventDefault();
    setShowAlert(false);
    try {
      const { data } = await axios.post(
        `${baseUrl}/recharge`,
        { amount },
        {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        }
      );
      // setMyRequests([data, ...MyRequests]);
      // setRechargeID(data.rechargeId);
      console.log(data);
      setVariance("success");
      setToastMessage(
        `Recharge request submitted successfully. Your reference ID is ${rechargeID}`
      );
      setShowToast(true);
      
      // SEND SMS
      function sendPaymentNotification2Admin() {
              if (data) {
                try {
                  const apiUrl = `https://apps.mnotify.net/smsapi?key=zwNY4rjo1XWnMXn8Om7Q8gk1U&to=233548785316&msg=Wallet recharge request made successfully by 0${userInfo.phone} for an amount of ¢${amount}&sender_id=KYE-TECH`;
                  fetch(apiUrl)
                  // .then((response) => response.json(response.data));
                  .then((response) => console.log('smsFeedback',response));
                } catch (error) {
                  console.error("Error sending SMS:", error);
                }
              }
            }
            sendPaymentNotification2Admin();
            setAmount(""); // Reset the input field
    } catch (error) {
      setVariance("danger");
      setToastMessage(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
      );
      setShowToast(true);
    }
  };

  const formContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    // minHeight: '70vh',
    flexDirection: "column",
  };

  return (
    <>
      <Container style={formContainerStyle}>
        <Form style={{ width: "300px" }}>
          <Form.Group className="m-1" controlId="amountPaid">
            <Form.Control
              type="number"
              placeholder="Topup amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              min="50"
              required
              title="Please enter an amount of at least 50.00"
              />
          </Form.Group>
              <p className="text-center">Available balance: &cent; {CurrUser?.balance.toFixed(2) || 0}</p>
          <Button
            onClick={processRequest}
            disabled={isNaN(parseFloat(amount)) || parseFloat(amount) < 50}
            variant="success"
            type="submit"
            className="w-100"
          >
            Pay
          </Button>
        </Form>
      </Container>
      <hr />
      <h2 className="text-center mt-3">TOPUP HISTORY</h2>
      {MyRequests.length > 0 ? (
        <div className="table-responsive" style={{ overflowX: "auto" }}>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Date</th>
                <th>Reference</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {MyRequests.map((request) => (
                <tr key={request._id}>
                  <td>{new Date(request.createdAt).toLocaleString()}</td>
                  <td>{request.rechargeId}</td>
                  <td>{request.amount}</td>
                  <td>
                    {request.status === "pending" ? (
                      <Button
                        variant="warning"
                        size="sm"
                        className="w-100"
                        disabled
                      >
                        {request.status}
                      </Button>
                    ) : request.status === "rejected" ? (
                      <Button
                        variant="danger"
                        size="sm"
                        className="w-100"
                        disabled
                      >
                        {request.status}
                      </Button>
                    ) : (
                      <Button
                        variant="success"
                        size="sm"
                        className="w-100"
                        disabled
                      >
                        {request.status}
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      ) : (
        <div className="text-center mt-4">
          <h4>No records found</h4>
        </div>
      )}
       <ToastIt
        Variance={variance}
        Message={toastMessage}
        ShowToast={showToast}
        OnClose={() => setShowToast(false)}
      /> 
      <Modal
        show={showAlert}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="bg-info" closeButton>
          <Modal.Title
            className="w-100 text-center"
            id="contained-modal-title-vcenter"
          >
            PAYMENT NOTICE
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center bg-light">
          <p>Make payment of <b>{amount}</b> </p>
          <span>ACCOUNT NUMBER</span>
          <h3 className="text-danger">{noticeContent.momoPhoneNumber}</h3>
          <hr />
          <span>ACCOUNT NAME</span>
          <p className="text-primary">
            {" "}
            <b>{noticeContent.momoAccountName}</b>
          </p>
          <p>USE THIS REFERENCE CODE </p>{" "}
          <h3 className="text-danger">{rechargeID}</h3> 
          CLICK ON I HAVE PAID AFTER SUCCESSFULLY SENT THE MONEY<br/>
          <Button variant="danger" onClick={handleRequest}>I have paid</Button>
        </Modal.Body>
        {/* <Modal.Footer className="bg-info text-center">
          <small>For any complaints, send sms to 0595548478</small>
        </Modal.Footer> */}
      </Modal>
    </>
  );
}

export default UserFinance;
